// skeleton — wireframe skin module
// vi-07: Wireframe skin NEVER animates, regardless of the effect attribute.
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: block;
    --_sk-border:  var(--run-skeleton-wireframe-border,  var(--run-color-border-subtle, #ccc));
    --_sk-radius:  var(--run-skeleton-radius,            4px);
    --_sk-bg:      transparent;
  }

  .sk-block {
    display: block;
    background: var(--_sk-bg);
    border: 1px solid var(--_sk-border);
    border-radius: var(--_sk-radius);
  }

  .sk-block-circular {
    border-radius: 50%;
  }

  .sk-lines {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
  }

  /* No animation rules in wireframe — vi-07 is enforced by omission. */
`;

/**
 * Render wireframe skeleton into host.shadowRoot.
 * No animation is ever applied in this skin (vi-07).
 *
 * @param {import('../run-skeleton.js').RunSkeleton} host
 */
export function render(host) {
  const variant = host.variant || 'text';
  const width   = host.width   || '100%';
  const height  = host._resolvedHeight;
  const lines   = host.lines   || 1;

  const circularClass = variant === 'circular' ? ' sk-block-circular' : '';

  if (variant === 'text' && lines > 1) {
    // vi-03: last line at 80% width
    const lineEls = Array.from({ length: lines }, (_, i) => {
      const isLast = i === lines - 1;
      const w      = isLast ? `calc(${width} * 0.8)` : width;
      return `<span class="sk-block" style="width:${w};height:${height};" aria-hidden="true"></span>`;
    });
    host.shadowRoot.innerHTML = `
      <div class="sk-lines" aria-hidden="true" part="base">${lineEls.join('')}</div>
    `.trim();
  } else {
    host.shadowRoot.innerHTML = `
      <span class="sk-block${circularClass}"
            style="width:${width};height:${height};"
            aria-hidden="true"
            part="base"></span>
    `.trim();
  }
}
